export const openWeatherMapApiKey =
  process.env.REACT_APP_OPEN_WEATHER_MAP_API_KEY;
